import { yupResolver } from '@hookform/resolvers/yup';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { InferType } from 'yup';

import { schema } from './schema';

export function useChatMessageMindFeedbackForm() {
  const values = useMemo(() => schema.getDefault(), []);

  const resolver = useMemo(() => yupResolver(schema), []);

  const form = useForm<InferType<typeof schema>>({
    resolver,
    defaultValues: values,
    mode: 'onChange',
  });

  return {
    form,
    formIsValid: useMemo(() => form.formState.isValid, [form.formState]),
  };
}
